<template>
  <div class="biddinghall_w bc_F2F2F2">
    <div class="content_w">
      <div class="site_content">

        <div class="top_w">
          <div class="breadcrumb_w d_flex align_item_c">
            <SiteBreadcrumb />


            <div
              style="margin-left:10px"
              class="dynamic_tabs_w d_flex "
              v-for="item in dynamicTabs"
              :key="item.tabType"
            >
              <div class="d_tab_i bc_fff fz12 c_1A1A1A">
                <span class="span_1">{{ item.value }}</span>
                <i
                  @click="setDynamicTabsVal(item.tabType)"
                  class="icon_i el-icon-close"
                ></i>
              </div>
            </div>


            <div class="div_3 d_flex justify_content_sb align_item_c">
              <span class="fz12 c_1A1A1A"
                >（共{{ projectDataRes.total }}条项目信息）</span
              >
              <span
                class="span_2 fz12 c_1A1A1A bc_fff cursor_pointer"
                @click="clearScreen"
                >清空筛选项</span
              >
            </div>
          </div>
        </div>

        <div class="div_1 bc_fff">
          <!-- 交易模式 -->
          <SwitchTabs
            :tabs="tradeModes"
            value-key="key"
            label-key="value"
            desc="交易模式:"
            @change="onTradeModeChange"
            v-model="screenForm.tradeMode"
          />
          <div class="solid_line" />
          <!-- 项目类型 -->
          <SwitchTabs
            :tabs="siteInfo.tradeKinds"
            value-key="key"
            label-key="value"
            desc="项目类型:"
            @change="onTargetTypeChange"
            v-model="screenForm.tradeKind"
          />
          <div class="solid_line" />
          <!-- 所在区域 -->
          <SwitchTabs
            :tabs="siteInfo.subsetRegions"
            value-key="key"
            label-key="value"
            desc="所在区域:"
            @change="onAreaChange"
            v-model="screenForm.locId"
            class="div_2 align_item_fs"
          />
          <div class="solid_line" />
          <!-- 项目状态 -->
          <SwitchTabs
            :tabs="stateList"
            value-key="key"
            label-key="value"
            desc="项目状态:"
            @change="onStateChange"
            v-model="screenForm.state"
          />
        </div>

        <div class="other_screen_w bc_fff d_flex">
          <div
            class="screen_i"
            :class="screenForm.sort === 0 ? 'active_sort' : ''"
            @click="onDefaultClick(0)"
          >
            默认
          </div>
          <div
            class="screen_i sort_price"
            :class="
              screenForm.sort === 1 || screenForm.sort === 2
                ? 'active_sort'
                : ''
            "
            @click="onSortPrice"
          >
            价格
          </div>
          <div
            class="screen_i"
            :class="screenForm.sort === 3 ? 'active_sort' : ''"
            @click="onDefaultClick(3)"
          >
            最新发布
          </div>
        </div>

        <div class="project_w">


          <component  v-for="item in projectDataRes.list"
            :key="item.id"
            :data="item"
            @click.native="onGoProjectItem(item.projectNo)" :is="projectItemTpl(item.tradeKind)" />

          <div
            v-if="projectDataRes.list && !projectDataRes.list.length"
            class="x_y_center empty_w"
          >
            <img src="@/assets/images/empty_icon.png" alt="" />
            <span style="margin: 0 0 0 10px" class="fz14">暂无数据</span>
          </div>
        </div>

        <div class="padding_1 d_flex justify_content_c">
          <!--分页-->
          <MyPagination
            :current-page="projectDataRes.pageNum"
            :total="projectDataRes.total"
            style="margin-top: 8px"
            change-method-name="getProjectList"
            :that="this"
            layout="total,sizes, prev, pager, next, jumper"
            :pageInfo="pageInfo"
            :pageSizes="[10, 20, 30, 40, 50]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchTabs from "@/components/base/SwitchTabs.vue";
import { mapGetters, mapActions } from "vuex";
import { auction_hall, project_list } from "@/api/portal";
import MyPagination from "@/components/base/MyPagination.vue";
import { uuid, filterRepeat, isEmtry } from "@/utils";

import SiteBreadcrumb from '@/components/base/SiteBreadcrumb.vue'
import OtherProjectItem from "@/components/template/otherTradeKind/ProjectItemA.vue";
import SmallmicroProjectItem from "@/components/template/smallmicro/ProjectItemA.vue";


export default {
  components: {
    SwitchTabs,
    MyPagination,
    SiteBreadcrumb,
    OtherProjectItem,
    SmallmicroProjectItem
  },
  metaInfo() {
    return {
      title: `${this.$route.meta?.title} ${this.siteInfo?.name ? ' - '+this.siteInfo.name:''}`
    }
  },
  data() {
    return {
      stateInfo: [
        {
          value: "3",
          label: "待成交",
        },
        {
          value: "4",
          label: "已成交",
        },
      ],

      //
      pageInfo: {
        page: 1,
        rows: 10,
      },
      projectDataRes: {},
      screenForm: {
        tradeMode:null,
        tradeKind: null,
        locId: null,
        state: null,
        sort: 0,
      }, // 筛选表单

      websocket: null,
      dynamicTabs: [], //动态tabs项
      biddingType: "",

      requestUrl: "",
      initComplete:false
    };
  },
  computed: {
    ...mapGetters(["siteInfo", "tradeKindKey" ,'tradeModes' ,'stateList']),

    //项目是否已结束（包含中止）
    isProjectEnd() {
      return function (stateCode) {
        return [4, 5].includes(stateCode);
      };
    },
    projectItemTpl() {
      return function (tradeKind) {
        switch(tradeKind){
          case 'smallmicro':return 'SmallmicroProjectItem';
          default : return 'OtherProjectItem'
        }
      };
    },
  },
  watch: {

    'screenForm.tradeMode'(n){
      this.screenForm.tradeMode = n === '' ? '' : n;
      this.getProjectList()
    },
    "screenForm.tradeKind": function (n, o) {
      this.screenForm.tradeKind = n === '' ? '' : n;
      this.getProjectList()
    },
    "screenForm.locId": function (n) {
      this.screenForm.locId = n === '' ? '' : n;
      this.getProjectList()
    },
    "screenForm.state": function (n) {
      this.screenForm.state = n === '' ? '' : n;
      this.getProjectList()
    },
    "screenForm.sort": function () {
      this.getProjectList();
    },
  },
  created() {
    this.initAreaInfo();
    this.getProjectList(this.pageInfo);
  },
  mounted(){
    window.scrollTo(0,0)
  },
  destroyed() {},

  methods: {
    ...mapActions({
      initAreaInfo: "cache/initAreaInfo",
    }),

    // 获取项目列表 api
    async getProjectList(params) {
      this.screenForm.uid = uuid(13);
      const { data } = await project_list(
        Object.assign(this.screenForm, params || this.pageInfo)
      );
      if (!data) {
        this.projectDataRes = {
          list: [],
          pageNum: 0,
          pageSize: 0,
          total: 0,
        };
        return;
      }
      this.projectDataRes = data;
      this.initComplete = true
    },

    // 设置竞拍大厅数据
    setListData(data) {
      for (const i in data) {
        this.setCountdown(i);
      }
    },

    //前往项目详情 click
    onGoProjectItem(projectNo) {
      this.$router.push({
          name:'projectDetail',
          query:{
            projectNo
          }
        });
    },

    // 交易模式 change
    onTradeModeChange(tab){
      this.setDynamicTabs(tab,'tradeMode')
    },
    // 标的物类型 change
    onTargetTypeChange(tab) {
      this.setDynamicTabs(tab,'tradeKind')
    },
    // 地区 change
    onAreaChange(tab) {
      this.setDynamicTabs(tab,'locId')
    },
    // 状态 change
    onStateChange(tab) {
      this.setDynamicTabs(tab,'state')
    },
    // 默认排序 click
    onDefaultClick(val) {
      this.screenForm.sort = val;
    },
    // 低价排序 click
    onSortPrice(val) {
      // sort：1和2切换
      if (this.screenForm.sort === 2 || this.screenForm.sort !== 1) {
        this.screenForm.sort = 1;
        return;
      }
      if (this.screenForm.sort === 1 || this.screenForm.sort !== 2) {
        this.screenForm.sort = 2;
      }
    },
    // 价格确认 click
    onPriceClick() {
      this.getProjectList(this.pageInfo);
    },

    //设置动态tabs
    setDynamicTabs(tab,tabType) {
      this.pageInfo.page = 1;
      this.dynamicTabs = this.dynamicTabs.filter(item=>item.tabType !== tabType)
      if(isEmtry(tab)) return
      tab.tabType = tabType
      this.dynamicTabs.push(tab);
    },
    // 设置动态tabs项value
    setDynamicTabsVal(tabType) {
      this.screenForm[tabType] = null;
      this.setDynamicTabs(null,tabType)
      this.getProjectList();
    },
    //清空筛选项 click
    clearScreen() {
      this.screenForm.tradeMode = null;
      this.screenForm.tradeKind = null;
      this.screenForm.locId = null;
      this.screenForm.state = null;
      this.dynamicTabs = []
      this.getProjectList(this.pageInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
.biddinghall_w {
  .empty_w {
    min-height: 200px;
    margin: 50px auto;
  }
  .dynamic_tabs_w {
    margin: 0 10px 0 0;
    .d_tab_i {
      border: 1px solid #e6e6e6;
      margin: 0 10px 0 0;
      padding: 5px 10px;
      &:last-child {
        margin: 0;
      }
      &:hover {
        cursor: pointer;
        color: #0983cc;
      }
      .icon_i {
        border-radius: 50%;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        &:hover {
          background-color: #c0c4cc;
          color: #fff;
        }
      }
    }
  }
  .breadcrumb_w {
  }
  .div_1 {
    border: 1px solid #e6e6e6;
  }
  ::v-deep .div_2 {
    padding: 17px 10px 0 10px;
    .desc_w {
      margin: 0;
    }
    .tabs_w {
      padding: 0;

      .active_tab {
        margin: 0 0 17px 0;
      }
      .tab_i {
        margin: 0 0 17px 0;
      }
    }
  }
  .div_3 {
    flex: 1;
  }
  .other_screen_w {
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #e6e6e6;
    .screen_i {
      padding: 10px 28px;
      font-size: 12px;

      color: #1a1a1a;
      border: 1px solid #e6e6e6;
      &:nth-child(even) {
        border-right: 0;
        border-left: 0;
      }
      &:hover {
        cursor: pointer;
        background-color: rgba($color: #e6e6e6, $alpha: 0.5);
      }
    }
    .sort_price {
      position: relative;
      &::before {
        content: "";
        position: absolute;
        width: 10px;
        height: 5px;
        top: 11px;
        right: 12px;
        background: url("~@/assets/images/up_arrow.png") 100% 100% / cover
          no-repeat;
      }
      &::after {
        content: "";
        position: absolute;
        bottom: 11px;
        right: 12px;
        width: 10px;
        height: 5px;
        background: url("~@/assets/images/down_arrow.png") 100% 100% / cover
          no-repeat;
      }
    }
  }

  .active_sort {
    background-color: rgba($color: #e6e6e6, $alpha: 0.5);
  }

  ::v-deep .el-pagination__sizes {
    display: none !important;
  }
  ::v-deep .el-breadcrumb {
    display: flex;
  }
  ::v-deep .el-breadcrumb__item,
  ::v-deep .el-breadcrumb__inner {
    display: flex;
    align-items: center;
  }
  .margin_1 {
    //null
    // margin: 0 0 0 50px;
  }
  .margin_2 {
    margin: 0 8px;
  }
  .margin_3 {
    margin: 0 14px 0 0;
  }
  .margin_4 {
    margin: 0 0 0 10px;
  }
  .margin_5 {
    margin: 0 0 0 24px;
  }
  .margin_6 {
    margin: 0 20px 0 0;
  }
  .padding_1 {
    padding: 21px 0;
  }
  .span_1 {
    margin: 0 20px 0 0;
  }
  .span_2 {
    padding: 6px 20px;
  }
  .project_w {
    display: flex;
    flex-wrap: wrap;
  }
  .content_w {
  }

  .screen_w {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    padding: 11px 21px;
    margin: 35px 0 0 0;
    .count_nav {
      // float: left;
    }
    .price_w {
      // float: left;
    }
    .sort_w {
      display: flex;
      align-items: center;
    }
  }
}
</style>
